/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../services.module.ts" />

module Meevo.Plugins.Services {
    class ServicePrerequisiteModalController {

        static $inject = ["context", "servicePrerequisite", "$mdDialog", "meevo.components.modal.ModalService", "dataService"]
        public context: any;
        public servicePrerequisite: Meevo.Model.ServicePrerequisite;
        protected editMode: boolean;
        public readOnly: boolean;
        public isAccessible: boolean;
        public dataService: Meevo.Components.BaseClasses.IDataService;
        public considerMainServiceAsPreReq: boolean;
        public alwaysValid: boolean;
        public selectedServicePrerequisite: any;
        public excludedServices: any[];
        public searchAheadCriteria: any = null;

        constructor(context: any, servicePrerequisite: Meevo.Model.ServicePrerequisite, private $mdDialog: ng.material.IDialogService, protected modalService: Meevo.Components.Modal.IModalService, dataService: Meevo.Components.BaseClasses.IDataService) {
            this.readOnly = context.isReadonly;
            this.editMode = context.editMode;
            this.isAccessible = context.isAccessible;
            this.context = context;
            this.dataService = dataService;
            this.servicePrerequisite = servicePrerequisite;
            this.excludedServices = this.context.selectedSection.model.servicePrerequisites ?
                this.context.selectedSection.model.servicePrerequisites.map((prereq) => { return { id: prereq.id, displayName: prereq.displayName } }) : [];
            if (this.context.selectedSection.model.id) {
                this.excludedServices.push({ id: this.context.selectedSection.model.id, displayName: this.context.selectedSection.model.displayName });
            }
            
            if (context.identityService.inCentralOfficeMode() && (context.homeLocationId !== context.locationId)) {
                this.searchAheadCriteria = {
                    coFilterByLocationId: context.locationId,
                    coSearchResultFilter: 0,
                    coSearchType: 1,
                    includeActive: true,
                    includeInactive: false,
                    includeDeleted: false
                }
            }
            if (servicePrerequisite) {
                this.servicePrerequisite = angular.copy(servicePrerequisite);
                this.editMode = true;
                this.alwaysValid = !this.servicePrerequisite.validForXDays;
                this.selectedServicePrerequisite = {
                    id: servicePrerequisite.id,
                    displayName: servicePrerequisite.displayName
                };
                return;
            }

            this.alwaysValid = true;
            this.servicePrerequisite = {
                id: "",
                validForXDays: null,
                considerMainServiceAsPreReq: true,
                displayName: ""
            }
        }

        selectService = () => {
            this.servicePrerequisite.id = this.selectedServicePrerequisite.id;       
            this.servicePrerequisite.displayName = this.selectedServicePrerequisite.displayName;
        }
        
        alwaysValidChanged = () => {
            if (this.alwaysValid) {
                this.servicePrerequisite.validForXDays = null;
            }
        }

        apply = (arr: any) => {

            if (!this.selectedServicePrerequisite) {
                this.modalService.warning("ERROR_SERVICE_REQUIRED_PROCEED", Components.Modal.ModalTranslationModes.Translate, true, {buttons: ['ok']});
                return;
            }
            const preReqs = [this.servicePrerequisite];
            this.context.selectedSection.model.servicePrerequisites = preReqs;
                
            this.$mdDialog.hide();
        }

        cancel = () => {
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.services")
        .controller("meevo.plugins.services.ServicePrerequisiteModalController", ServicePrerequisiteModalController);
}